/**
 * @desc sku最小或最大的MOQ
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierQuotation.getMinOrMaxSupplierQuotation.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/getMinOrMaxSupplierQuotation`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
